import axios from '@/utils/axios'
import { getParmeterSplic } from '@/utils/utils'
/**
 * @description  预警规则-分页获取模板列表
 * @param params
 * pageSize 分页查询每页数据条数 
 * pageNum 分页查询第X页
 * keyword 检索关键词
 * orderColumn 排序字段
 * order 按何顺序
 * @returns
 */
export async function getTableData(params) {
  return axios.get(`/v2/feedback/api/forewarning/base/list`,{params})
}
/**
 * @description  预警规则-删除预警规则
 * @param params
 * id 被复制的ID 
 * @returns
 */
 export async function warningDelete(params) {
  return axios.delete(`/v2/feedback/api/forewarning/detail?id=${params.id}`)
}
/**
 * @description  预警规则-新建预警规则
 * @param params
 * @returns
 */
 export async function warningCreate(params) {
  return axios.post(`/v2/feedback/api/forewarning/detail`,params)
}
/**
 * @description  预警规则-获取预警模板列表
 * @param params
 * @returns
 */
 export async function warningTemplateList(params) {
  return axios.get(`/v2/feedback/api/template/name?type=3&sourceId=0`)
}
/**
 * @description  预警规则-新建模板名称
 * @param params
 * @returns
 */
 export async function warnAdd(params) {
  return axios.post(`/v2/feedback/api/forewarning/detail`,params)
}
/**
 * @description  预警规则-新建模板名称
 * @param params
 * @returns
 */
 export async function warnEdit(params) {
  return axios.put(`/v2/feedback/api/forewarning/detail`,params)
}
/**
 * @description  预警规则-获取预警规则详情
 * @param params
 * id 模板id
 * view true时仅查看、false时编辑时显示
 * @returns
 */
 export async function getWarningDetail(params) {
  return axios.get(`/v2/feedback/api/forewarning/detail?id=${params.id}&view=${params.view}`)
}
/**
 * @description  预警规则-获取预警规则操作记录
 * @param params
 * id 模板id
 * @returns
 */
 export async function getTemplateoOperationLog(params) {
  return axios.get(`/v2/feedback/api/template/operationLog`)
}
/**
 * @description  预警规则-问卷详情
 * @param surveyId 问卷ID
 * @returns
 */
export const getSurveyDetail = async (surveyId) => {
  return axios.get(`/v2/survey/${surveyId}`)
}
/**
 * @description  预警规则-问卷列表
 * @param params
 * @returns
 */
export const getSurveyList = async (params) => {
  return axios.get('/v2/survey', { params })
}
/**
 * @description  预警规则-修改预警状态
 * @param params
 * @returns
 */
 export const editStatus = async (params) => {
  return axios.put('/v2/feedback/api/forewarning/status', params)
}
/**
 * @description  预警规则-获取审核状态信息
 * @param params
 * @returns
 */
 export const getAuditInfo = async (params) => {
  return axios.get(`/v2/feedback/api/forewarning/auditInfo?id=${params.id}`)
}
/**
 * @description  预警规则-获取审核人
 * @param params
 * @returns
 */
 export const getAccountIT = async (params) => {
  return axios.get(`/v2/rbac/accountIT`)
}
/**
 * @description  预警规则-提交审核
 * @param params
 * @returns
 */
 export const submitAudit = async (params) => {
  return axios.post(`/v2/feedback/commonApi/submitAudit`,params)
}
/**
 * @description  预警规则-分页获取调研列表
 * @param params
 * @returns
 */
 export const getResearchList = async (params) => {
  return axios.get(`/v2/feedback/api/research/base/list?${getParmeterSplic(params)}`)
}
/**
 * @description  预警规则-获取动态参数信息
 * @param params
 * @returns
 */
 export const getDynamicInfo = async (params) => {
  return axios.get(`/v2/feedback/api/template/dynamicInfo?${getParmeterSplic(params)}`)
}
/**
 * @description  预警规则-撤回审核
 * @param sourceType 4  3调研 4预警 5订阅
 * @param sourceId 4 资源id
 * @returns
 */
 export const callAuditRecall = async (params) => {
  return axios.put(`/v2/feedback/auditRecall?${getParmeterSplic(params)}`)
}